import * as Yup from 'yup';

// eslint-disable-next-line import/prefer-default-export
export const reportsValidationSchema = Yup.object({
  reports: Yup.object({
    full: Yup.array().of(Yup.string()),
    mini: Yup.array().of(Yup.string()),
  }),
});
